import FadeIn from 'react-fade-in';

import profile from '../assets/images/alex.jpg';

import './home.css';

export default function Home() {
    return (
        <FadeIn className="home" childClassName='homeElement'>
            <img src={profile} alt="Profile" className="photo fadein" />
            <p className="description fadein">Hi, my name is Alex and I'm a software developer
                at <b><a className='homeLink' href='https://www.google.com' target='_blank' rel='noreferrer'>Google</a></b>.
                I've been developing full-stack software applications since 2015 - from simple websites to enterprise level data pipelines.</p>
        </FadeIn>
    )
}